import './intestazione.scss';

/**
 * version    1.0
 * class      <type> (Intestazione)
 * classdesc
 */
export class Intestazione {}
